/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Slug_FieldInputs */

const en_admin_categories_slug_field = /** @type {(inputs: Admin_Categories_Slug_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug`)
};

const zh_admin_categories_slug_field = /** @type {(inputs: Admin_Categories_Slug_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标识`)
};

/**
* | output |
* | --- |
* | "Slug" |
*
* @param {Admin_Categories_Slug_FieldInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_slug_field = /** @type {((inputs?: Admin_Categories_Slug_FieldInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Slug_FieldInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_slug_field(inputs)
	return zh_admin_categories_slug_field(inputs)
});
export { admin_categories_slug_field as "admin.categories.slug_field" }